import React, { useState } from "react";
import { FaPlaneArrival, FaPlaneDeparture } from "react-icons/fa";
import { minutesToHrMin, parseTerminalName, StampTo24hr } from "../../../../../../../../Utils/utils";
import { Img } from "../../../../../../../../Components";
import { FiInfo } from "react-icons/fi";
import Layovers from "./layovers";
import moment from "moment";

function FlightCard({ onwardDuration, returnDuration, onwardSegments = [], returnSegments = [], className = "" }) {
	const [ShowLayovers, setShowLayovers] = useState();

	return [onwardSegments, returnSegments].map((segments, index) => {
		const departure = segments[0];
		const arrival = segments[segments.length - 1];
		const { departureTerminal, logo, departureTime, airlineName, airlineCode, flightNumber, departureCode } = departure || {};
		const { arrivalTime, arrivalCode, arrivalTerminal } = arrival || {};

		return (
			<div key={index} className="col-span-2">
				<div className={`flex-grow p-4 align-center gap-x-4 ${className}`}>
					<div className="min-w-[6rem]">
						<Img src={logo} alt={airlineCode} className="w-10 h-10 rounded-full !bg-canvas" />
						<div className="mt-2 text-xs text-secondary">
							{airlineName} <br />
							{airlineCode}-{flightNumber}
							<br />
							{moment.utc(departureTime).format("DD MMM YYYY")}
						</div>
					</div>
					<div className="max-w-[8rem]">
						<div className="text-xl font-bold whitespace-nowrap">{StampTo24hr(departureTime)}</div>
						<div className="text-sm text-secondary">{departureCode}</div>
						{departureTerminal && <div className="text-xs text-secondary">{parseTerminalName(departureTerminal)}</div>}
					</div>
					<div className="flex-grow min-w-[5rem]">
						<div className="mb-2 text-xs text-center text-secondary whitespace-nowrap">{index === 0 ? minutesToHrMin(onwardDuration) : minutesToHrMin(returnDuration)}</div>
						<div className="align-center">
							<div className="w-2 h-2 border rounded-full border-dark" />
							<div className="flex-grow border-t border-dashed border-muted" />
							{index === 0 ? <FaPlaneDeparture /> : <FaPlaneArrival />}
							<div className="flex-grow border-t border-dashed border-muted" />
							<div className="w-2 h-2 border rounded-full border-dark" />
						</div>
						<div className="mt-2 text-xs text-center text-secondary whitespace-nowrap">
							{segments.length === 1
								? "Non-Stop"
								: `${segments.length - 1} stop (via ${segments
										.slice(1)
										?.map((segment) => `${segment.departureCode}`)
										.join(", ")})`}
						</div>
					</div>
					<div className="max-w-[8rem]">
						<div className="text-xl font-bold whitespace-nowrap">{StampTo24hr(arrivalTime)}</div>
						<div className="text-sm text-secondary">{arrivalCode}</div>
						{arrivalTerminal && <div className="text-xs text-secondary">{parseTerminalName(arrivalTerminal)}</div>}
					</div>
				</div>
				{segments.length > 1 && (
					<div onClick={() => setShowLayovers(segments)} className="gap-2 p-2 border-t rounded-bl cursor-pointer flex-center bg-light hover:bg-canvas">
						<div className="gap-1 text-xs text-secondary flex-center">
							<FiInfo />
							Layovers
						</div>
						{segments.map((segment, i) => (
							<>
								<div key={i} className="w-5 h-1 mt-1 border-t border-dotted border-secondary" />
								<Img src={segment.logo} alt={airlineCode} className="w-6 h-6 rounded-full" />
							</>
						))}
					</div>
				)}
				<Layovers segments={ShowLayovers} onClose={() => setShowLayovers()} />
			</div>
		);
	});
}

export default FlightCard;
